import { BehaviorSubject } from 'rxjs';
export const getLegislationArticleStore = () => {
    const getInitialState = () => ({
        articleContent: ''
    });
    const legislationArticleSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => legislationArticleSubject.subscribe(callback);
    const setArticleContent = (articleContent) => {
        legislationArticleSubject.next({ articleContent });
    };
    const reset = () => {
        legislationArticleSubject.next(getInitialState());
    };
    return {
        getInitialState,
        subscribe,
        setArticleContent,
        reset
    };
};
